import React from 'react';
import { withTranslation } from 'react-i18next';
import Background from '../Background';
import Styled from '../../../shared/components/SchemeComponent/styles';
import SchemeComponent from '../../../shared/components/SchemeComponent';
import Minimap from '../Minimap';

class Scheme extends SchemeComponent {
  render() {
    const { isFullscreen, hidden } = this.props;
    const { isPeriodical } = window.Widget.metaController.meta;

    return (
      <Styled.Container isHidden={hidden}>
        <Styled.Overlay isFullscreen={isFullscreen} isPeriodical={isPeriodical}>
          <Styled.Layout data-cyid="layout" ref={this.getOverlay}>
            <Background />
          </Styled.Layout>
        </Styled.Overlay>
        {!window.Widget.isMobile && !window.Widget.settings.withAnnouncements && (
          <Minimap
            onDrag={this.moveMinimap}
            isFullscreen={isFullscreen}
            getOnDragCallback={this.setOnMinimapDragCallback}
          />
        )}
      </Styled.Container>
    );
  }
}

// @ts-ignore
export default withTranslation()(Scheme) as any;
